module.exports = __webpack_public_path__ + "static/media/warc-banniere.6987a3d9.png";